// types of promo banners
export const PROMO_BANNER_TYPES = {
  PromoCodeBanner: 'PromoCodeBanner',
  LoyaltyBanner: 'LoyaltyBanner'
} as const

// core promo banner interface
interface PromoBannerInterface {
  // guid - unique identifier
  bannerGuid: string
  // main text of the banner
  bannerText: string
  // banner type
  __typename: keyof typeof PROMO_BANNER_TYPES
}

// promo code banner type
export interface PromoCodeBanner extends PromoBannerInterface {
  __typename: typeof PROMO_BANNER_TYPES.PromoCodeBanner
  // the promo code
  promoCode: string
}

// loyalty code banner type
export interface LoyaltyBanner extends PromoBannerInterface {
  __typename: typeof PROMO_BANNER_TYPES.LoyaltyBanner
  // optional time availability of the loyalty points offer
  availability: PromoBannerAvailability | null
}

// time availability of a banner, if null, no time constraints
export type PromoBannerAvailability = {
  time: {
    startTime: string
    endTime: string
  } | null
}

// promo banner response
export type PromoBannerData = {
  promoCodeBanners: PromoCodeBanner[]
  loyaltyBanners: LoyaltyBanner[]
}

export type PromoBanner = PromoCodeBanner | LoyaltyBanner
